/**
 * @deprecated Replaced with UserRole from package/auth
 */
export enum UserRole {
  Manager = 'Manager',
  Viewer = 'Viewer',
}

export interface IUser {
  email: string;
  roles: UserRole[];
  userId?: string;
  username: string;
  firstName: string;
  lastName: string;
}

export interface IUserForm {
  email?: string;
  roles?: UserRole[];
  password?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
}
